import { MolsonBox, MolsonIcon, MolsonTypography } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
export const WarningChip = ({ text }: { text: string }) => {
  const theme = molsonUseTheme()

  return (
    <MolsonBox
      sx={{
        py: 0.75,
        px: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        backgroundColor: theme.palette.primary.warningBannerBg,
        border: `1px solid ${theme.palette.primary.warningBorderSecondary}`,
        borderRadius: '25px'
      }}
    >
      <MolsonIcon
        variant="WARNING"
        fontSize="small"
        iconColor="warning"
        dataTestId="chip-icon"
      />
      <MolsonTypography
        variant="subtitle2"
        color={theme.palette.primary.warningContent}
      >
        {text}
      </MolsonTypography>
    </MolsonBox>
  )
}
